<main class="promo-score-container">
    <h2>Puntuación de promociones</h2>
    <div class="products-container">
        <app-product-card *ngFor="let product of allPromotions" [product]="product"></app-product-card>
    </div>
</main>